module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "z-check-list",
    class: {
      'inline': _vm.$props.inline
    }
  }, [(_vm.$props.label) ? _c('label', {
    staticClass: "list-label"
  }, [_vm._v(_vm._s(_vm.$props.label))]) : _vm._e(), _c('div', {
    staticClass: "z-check-list-items"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c2aaba4","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZCheckList.vue
// module id = 1093
// module chunks = 0